module.exports = __webpack_public_path__ + "img/gushi_pic3.10192181.png";